module.exports = __webpack_public_path__ + "static/Redux-c3045a611c371b5454a60377179008fe.png";